import Loader from "components/Loader/loader"
import Configs from "../config"
import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { fetchData } from "utils/Common_api_functions"
import Breadcrumb from "components/Common/Breadcrumb"

const AdminTutorials = () => {
  const [video, setVideo] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchHelpData()
  }, [])

  async function fetchHelpData() {
    const APIdata = await fetchData(setLoading, "help")
    if (APIdata?.success) {
      console.log(APIdata?.data?.filter(item => item?.type === "Admin"))
      setVideo(APIdata?.data?.filter(item => item?.type === "Admin"))
    } else {
      setVideo([])
      console.log("Error Fetching Records", APIdata?.response)
    }
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb
          title="Dashboard"
          breadcrumbItem="Admin Tutorials"
          description="View Tutorials for Admin Panel and Understand How to use it"
        />

        {loading && <Loader />}

        <Row>
          {video?.map(item => (
            <Col xl="3" className="" key={item?.id}>
              <Card className="shadow-lg rounded-4">
                <CardBody>
                  <video
                    src={`${Configs.imageUrl}${item?.media}`}
                    className="w-100 object-fit-cover"
                    controls
                  />
                  <h5 className="fw-bold mt-3">{item?.title}</h5>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  )
}

export default AdminTutorials
